import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Tag = styled(Chip)(({ theme, color }) => {
  const commonStyles = {
    color: theme.palette.common.white,
    borderRadius: "4px",
    height: "19px",
    fontSize: "12px",
    padding: "3.5px 10.5px",
    fontWeight: "bold",
    "& .MuiChip-label": {
      padding: "0",
    },
  };

  if (color === "primary") {
    return {
      ...commonStyles,
      background: theme.palette.common.white,
      color: theme.palette.primary.main,
    };
  }

  if (color === "secondary") {
    return {
      ...commonStyles,
      background: theme.palette.secondary.gradient,
    };
  }

  return commonStyles;
});
